<button
  class="bg-surface border border-solid border-primary rounded p-3 cursor-pointer shadow text-left w-full hover:bg-hover"
  [disabled]="disabled"
  (click)="startScan()"
>
  <div class="flex flex-row gap-3 items-center">
    <div class="flex items-center align-middle">
      <i class="fa-regular fa-barcode-scan fa-2x"></i>
    </div>
    <div class="flex flex-col gap-0">
      <div class="font-semibold text-lg">
        {{
          label ? (label | translate) : ('#APPLICATION.SCANNER.BUTTON.TITLE' | translate)
        }}
      </div>
      <div class="color-light text-sm mt-0 hidden sm:block">
        {{ '#APPLICATION.SCANNER.BUTTON.DESCRIPTION' | translate }}
      </div>
    </div>
  </div>
</button>
